var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBuild = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M849.372,750.628h0L469.063,370.318A175.111,175.111,0,0,0,244.385,159.029l98.293,98.293h0a25,25,0,0,1,0,35.355l-75,75a25,25,0,0,1-35.356,0l-98.293-98.293A175.106,175.106,0,0,0,345.318,494.062l380.31,380.31h0A87.5,87.5,0,0,0,849.372,750.628Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuild, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Build.734da4f5.svg";
export { ForwardRef as ReactComponent };